import { useFormContext } from 'react-hook-form';
import { getVmsTypesList, VmsType } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import WsFilterProps from '../../../components/filters/models/WsFilterProps';

import WsAccordion from './WsAccordion';
interface vmsFilterProps extends WsFilterProps {
  hideAccordian?: boolean;
  multiple?: boolean;
  disable?: boolean;
}

const VmsFilter = ({
  name,
  title,
  hideAccordian = false,
  multiple = true,
  disable = false,
}: vmsFilterProps) => {
  const { setValue } = useFormContext();
  const onVmsInputKey = async (keyword: string) => {
    const result = await getVmsTypesList();
    const vmsTypes: VmsType[] = result.data;
    return vmsTypes
      .filter((vmsObj) => vmsObj.text.toLowerCase().includes(keyword.toLowerCase()))
      .map((vmsObj) => vmsObj.text);
  };
  const onChange = (data) => setValue(name, data);
  const input = (
    <WsAutocompleteInput
      getOptions={onVmsInputKey}
      onChange={onChange}
      options={[]}
      placeholder="Eg, Michael"
      multiple={multiple}
      freeSolo={false}
      name={name}
      size="small"
      focused={false}
      requireSelection={false}
      disable={disable}
    />
  );

  return (
    <>{!hideAccordian ? <WsAccordion title={title ?? 'Job Source'}>{input}</WsAccordion> : input}</>
  );
};
export default VmsFilter;
